import axios from "axios";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const checkTokenUser = async () => {
  const token = localStorage.getItem("token_key") || "";
  const username = localStorage.getItem("username") || "";

  try {
    const result = await axios({
      method: `Get`,
      url: `${process.env.REACT_APP_URL_API}/api/User/${username}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (err) {
    console.log("err get");
  }
};

export default function Provider() {
  const [dataUser, setDataUser] = useState({});
  useEffect(() => {
    async function checkData() {
      const tokenUser = await checkTokenUser();

      setDataUser(tokenUser);
    }

    checkData();
    // console.log(dataUser);
  }, []);

  if (dataUser !== null && dataUser !== undefined) {
    // toast.success("Login success!");
    return <Outlet />;
  } else return <Navigate to="/login" />;
}
